import { useEffect, useState } from "react";
import tw from "twin.macro";
import Skeleton from "react-loading-skeleton";
import SEO from "components/headers/Seo";
import "./PolicyPages.css";

const Heading = tw.h1`text-center block text-black font-bold text-3xl m-0 py-2 uppercase border-b-2 border-custom-100`;

export default ({ configImages, branch }) => {
  const [banner, setBanner] = useState([]);

  useEffect(() => {
    const getBanner = () => {
      configImages &&
        configImages.E_COMMERCE_BANNERS.forEach((data) => {
          if (data.key === "refundPolicy") {
            setBanner(data.value);
          }
        });
    };
    getBanner();
    //eslint-disable-next-line
  }, []);

  let Site_Url = "http://www.venkateswarajewellery.com";
  const Name = 'PMR Venkateswara Jewellery'

  const list = [
    {
      title: "RETURN & EXCHANGE POLICY",
      description: `${Name} strives hard in ensuring the satisfaction of every customer who have purchased or ordered with it. The process of return and exchange of the product purchased online via ${Site_Url} is designed as simple and user friendly as possible.`,
      show: "show",
    },
    {
      title: "i) Terms for Return before Delivery",
      description: `If a customer prefers to return the product ordered or purchased before delivery for some valid reason, ${Name} provides them with an option to do so and this shall be considered as 'Cancellation before Delivery'. Check cancellation terms section.`,
      show: "",
    },
    {
      title: "ii) Terms for Return on defects",
      description: `Customer may return the delivered product if found to be defective upon arrival at customer location. Customer shall exercise this privilege only for genuine faults and ${Name} hopes the facility is not misused. You are permitted to return jewels housing genuine wears, manufacturing defects, missing stones, cracks on the stones provided the jewel is unused. In such a case it has to be reported to ${Site_Url} as 'Defective upon delivery', on the date of delivery itself. Return of jewellery is also reasonable and acceptable in cases where the jewel delivered to you is different from what was ordered if it remains unused. ${Name} reserves every right in determining if the product delivered can be considered as 'Defective upon delivery'.`,
      description2: `If the customer tampered the jewel deliberately with or without the intention of usurping financial benefits, legal action will be taken under all applicable laws for cheating, theft, forgery etc., for the damage or defamation caused to the company. In such an event, ${Name} apart from initiating legal actions against such customer shall also penalize by not refunding the amount paid towards the purchase of jewel. Users, beware of the fact that ${Name} maintains every record- visual, factual as well as legal information about the product that is shipped. Care should be taken while returning through courier. The product should be returned in same condition as delivered by ${Name}.`,
      show: "",
    },
    {
      title: "iii) Terms for Return on Dissatisfaction - Limited Duration",
      description: `In case, the customer is not satisfied with the product after receiving they can return the product within 15 days from the delivered date. Return policy is subject to the following conditions:\n\na) The product should be returned in the same condition as delivered by ${Name}.\n\nb) Product showing sign of wear or engraved, altered, resized or damaged may not be accepted and may be returned to the customer itself.\n\nc) Products that are designed based on Customer's specification or customized jewels or Gold coins can be exchanged only at the showrooms of ${Name} binding by the terms stated under 'Lifetime Exchange'.\n\nd) Once the return is confirmed at the call center, ${Name} will send a packaging cover through the courier agent, which has to be used to return the product. 'Jewel to be returned' must be properly packed as per the associated logistics company's requirement.\n\ne) The item has to be packed in front of the courier agent.`,
      description2: `f) Product invoice provided by ${Name} must be sent along with the 'Jewel to be returned' while returning. Else return process shall be void.\n\ng) It is presumed that users are aware about Jewellery and the right way of handling them before purchase and ${Name} shall not take responsibility for any wear or damage caused by inappropriate handling or improper placement. Return or refund or exchange of such products of such a case shall not be entertained by ${Name}.\n\nh) Once ${Name} receives the jewel genuinely as stated above, the refund of the payment shall be promptly initiated within 15 days without deduction of shipping, processing fee and bank transaction charges through internet banking or cheque to the bank account that was used for the purchase.`,
      show: "",
    },
    {
      title: "v) Terms for Exchange",
      description: `In case you wish to exchange your item with in 15 days from the date of purchase for an alternative product, we suggest that you return the product for a credit and purchase the new product separately. For any exchange of certain products, user may confirm it with the support team of ${Name}. ${Site_Url} may offer a complimentary free return shipping for exchange of certain products. User may confirm it with the support team of ${Name}. Customer may return the product for exchange within 15 days for full invoice value. User shall bear the varied price of the new product purchased if it's current invoice value is greater than previously generated invoice value, of the returned item(s), and if the current invoice value is lesser than the previous invoice value ${Name} shall process the difference amount to the source bank account of the customer. Customized jewels and Gold coins are not eligible for return shipping and shall be exchanged only at our showrooms.`,
      show: "",
    },
    {
      title: "iv) Terms for Gifts",
      description: `Return of 'gifts' (as defined in Annotation section) shall follow the 'Return on dissatisfaction - Limited Duration', 'Return on defects', 'Lifetime Exchange', provided the beneficiary must bring the photo identity card recognized as photo Identity proof by Government of India, to prove the genuinity as the beneficiary considered by the customer who purchased the product.`,
      show: "",
    },
    {
      title: "Repairs",
      description: `In case the jewels bought needs repair, it has to be given in any of the showrooms of ${Name}. The customer must produce the invoice of the purchase. Customer must bear the repair charges as informed by ${Name}.`,
      show: "",
    },
    {
      title: "Insurance",
      description: `Insurance is provided during the transit of every purchase. The insurance will be valid when the merchandise is dispatched and will be void the moment following delivery to the respective customer or beneficiary i.e., the insurance becomes void or ceases once the receipt for delivery is acknowledged.`,
      show: "",
    },
  ];

  return (
    <>
      <SEO
        title="Refund Policy - PMR Venkateswara Jewellery"
        description="Refund Policy of PMR Venkateswara Jewellery."
        name="Company name."
        type="article"
      />
      <div tw="relative font-display overflow-hidden" className="custom_background pmr-policy-page">
        {/* Banner */}
        {banner && banner.length > 0 ? (
          <img src={banner} alt="Refund Policy" className="w-100" style={{ maxHeight: 220, objectFit: "cover" }} />
        ) : (
          <Skeleton tw="w-full" style={{ height: "200px" }} />
        )}

        {/* Page title */}
        <div className="pmr-policy-title-wrap">
          <p className="pmr-policy-eyebrow">PMR Venkateswara Jewellery</p>
          <Heading>RETURN & EXCHANGE POLICY</Heading>
        </div>

        {/* Accordion */}
        <div className="container py-2 py-sm-5">
          <div className="accordion pmr-policy-accordion" id="accordionRefund">
            {list.map((data, index) => (
              <div className="accordion-item pmr-policy-accordion-item" key={index}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button pmr-policy-accordion-btn text-uppercase"
                    type="button"
                    data-bs-toggle="collapse"
                  >
                    {data.title}
                  </button>
                </h2>
                <div
                  id={`refund${index}`}
                  className="accordion-collapse collapse show ptSans"
                  data-bs-parent="#accordionRefund"
                >
                  <div className="accordion-body pmr-policy-accordion-body">
                    <p>{data.description}</p>
                    {data.description2 && <p>{data.description2}</p>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};